function ie_version() {
	if (/MSIE 10/i.test(navigator.userAgent)) {
		return 10;
	}

	if (/MSIE 9/i.test(navigator.userAgent)) {
		return 9;
	}

	if (/rv:11.0/i.test(navigator.userAgent)) {
		return 11;
	}

	if (/Edge\/\d./i.test(navigator.userAgent)){
		return 'edge';
	}

	return null;
}

function is_mobile_safari(){
	if ((/iPad|iPhone|iPod/.test(navigator.userAgent)) && (/Safari/i.test(navigator.userAgent)) && !(/Chrome/i.test(navigator.userAgent))) {
		return true;
	}
}